module.exports = __webpack_public_path__ + "img/icon_map_6_off_100.cd4a424c.png";